const CONST = {
    templateName: 'box',
    templatePrimeAcquisitionName: 'boxAcquisition',
    templatePrimeRepeatName: 'boxRepeat',
    selectedBagIcon: 'odf-spot-bags-tick',
    selectedIcon: 'odf-icon-tick',
    notSelectedBagIcon: 'odf-spot-bags-warning-orange',
    noCoverageBagIcon: 'odf-spot-bags',
    warningIcon: 'odf-icon-warning',
    informationIcon: 'odf-icon-information',
    warningText: 'odf-text-warning',
    positiveText: 'odf-text-positive',
    infoText: 'odf-text-info',
    strongText: 'odf-strong',
    largeText: 'odf-text-lg',
    mediumText: 'odf-text-md',
    smallText: 'odf-text-sm',
};

class UIDataBuilder {
    constructor(constants = {}) {
        this.CONST = Odigeo._.merge({}, CONST, constants);
    }

    getData(keys, data = {}) {
        const defaultData = this.defaultData(keys);
        return Odigeo._.merge({}, defaultData, data);
    }

    defaultData(keys) {
        return {
            template: {
                name: this.CONST.templateName,
            },
            parent: {
                base: {
                    icon: {
                        classes: this.CONST.notSelectedBagIcon,
                    },
                    title: {
                        text: '',
                    },
                    persuasiveMessage: {
                        text: '',
                        classes: '',
                    },
                    button: {
                        text: '',
                    },
                    additionalInfo: {
                        text: '',
                        classes: this.CONST.warningText,
                    },
                    discountInfo: {
                        text: '',
                        classes: '',
                    },
                },
                selected: {
                    icon: {
                        classes: this.CONST.selectedBagIcon,
                    },
                    title: {
                        text: keys.cardTitleAdded,
                    },
                    persuasiveMessage: {
                        text: '',
                        classes: '',
                    },
                    button: {
                        text: keys.cardButtonReview,
                    },
                    additionalInfo: {
                        text: '',
                        classes: '',
                    },
                    discountInfo: {
                        text: '',
                        classes: '',
                    },
                },
            },
            child: {
                hide: false,
                base: {
                    title: {
                        text: keys.widgetTitle,
                    },
                    button: {
                        text: keys.widgetButtonConfirm,
                    },
                    footer: {
                        message: {
                            text: '',
                            classes: '',
                        },
                        icon: {
                            classes: '',
                        },
                    },
                    informativeMessage: {
                        messageAdditionalClasses: '',
                        messageIcon: '',
                        messageTitle: '',
                        messageSubtitle: '',
                        color: '',
                    },
                },
                selected: {
                    title: {
                        text: keys.widgetTitle,
                    },
                    button: {
                        text: keys.widgetButtonConfirm,
                    },
                    footer: {
                        message: {
                            text: '',
                            classes: '',
                        },
                        icon: {
                            classes: '',
                        },
                    },
                    informativeMessage: {
                        messageAdditionalClasses: '',
                        messageIcon: '',
                        messageTitle: '',
                        messageSubtitle: '',
                        color: '',
                    },
                },
            },
            promoBadge: {},
            enablePromoBadge: false,
            productAvailable: true,
        };
    }

    noIncludedAndSelectable(keys) {
        return {
            parent: {
                base: {
                    title: {
                        text: keys.cardTitleAvailable,
                    },
                    additionalInfo: {
                        text: keys.cardMessageNotIncluded,
                    },
                    button: {
                        text: keys.cardButtonAvailable,
                    },
                },
            },
            enablePromoBadge: true,
        };
    }

    noIncludedAndNoSelectable(keys) {
        return {
            parent: {
                base: {
                    icon: {
                        classes: this.CONST.noCoverageBagIcon,
                    },
                },
            },
            productAvailable: false,
        };
    }

    allRowsIncludedAndExtra(keys, includedBaggageInformativeMessage) {
        return {
            parent: {
                base: {
                    title: {
                        text: keys.cardTitleExtraBagsAvailable,
                    },
                    additionalInfo: {
                        text: includedBaggageInformativeMessage,
                        classes: this.CONST.infoText,
                    },
                    button: {
                        text: keys.cardButtonAvailable,
                    },
                },
            },
            enablePromoBadge: true,
        };
    }

    allRowsIncludedAndNoExtra(keys, includedBaggageInformativeMessage) {
        return {
            parent: {
                base: {
                    icon: {
                        classes: this.CONST.selectedBagIcon,
                    },
                    title: {
                        text: keys.cardTitleUnavailable,
                    },
                    additionalInfo: {
                        text: includedBaggageInformativeMessage,
                        classes: this.CONST.positiveText,
                    },
                    button: {
                        text: keys.cardButtonUnavailable,
                    },
                },
            },
            productAvailable: false,
        };
    }

    someRowsIncludedAndSelectable(keys, includedBaggageInformativeMessage) {
        return {
            parent: {
                base: {
                    title: {
                        text: keys.cardTitleAvailable,
                    },
                    additionalInfo: {
                        text: keys.cardMessageSomeIncludedNegative,
                    },
                    button: {
                        text: keys.cardButtonAvailable,
                    },
                },
            },
            enablePromoBadge: true,
        };
    }

    someRowsIncludedAndNoSelectable(keys) {
        return {
            parent: {
                base: {
                    icon: {
                        classes: this.CONST.noCoverageBagIcon,
                    },
                    title: {
                        text: keys.cardTitleUnavailable,
                    },
                    additionalInfo: {
                        text: keys.cardMessageSomeIncludedPositive,
                    },
                    button: {
                        text: keys.cardButtonUnavailable,
                    },
                },
            },
            productAvailable: false,
        };
    }

    trainStandalone(keys) {
        return {
            parent: {
                base: {
                    title: {
                        text: keys.trainStandalone,
                    },
                    icon: {
                        classes: this.CONST.selectedBagIcon,
                    },
                },
                selected: {
                    title: {
                        text: keys.trainStandalone,
                    },
                },
            },
            productAvailable: false,
        };
    }

    promoBadge(keys, primeInfo = {}) {
        return {};
    }

    isVinFlight(keys, baggageInfo = {}) {
        let data = {
            parent: {
                base: {
                    additionalInfo: {
                        text: keys.vinMessage,
                        classes: this.CONST.infoText,
                    },
                },
                selected: {
                    title: {
                        text: keys.vinTitle,
                    },
                    persuasiveMessage: {
                        text: keys.vinMessage,
                    },
                },
            },
        };

        if (baggageInfo.allRowsIncludedAndNoExtra) {
            Odigeo._.merge(data, {
                parent: {
                    base: {
                        persuasiveMessage: {
                            text: keys.vinMessage,
                        },
                        additionalInfo: {
                            text: baggageInfo.includedBaggageInformativeMessage,
                        },
                    },
                },
            });
        }

        return data;
    }

    primeAcquisition(keys, templates, primeInfo = {}) {
        return {
            template: {
                name: this.CONST.templatePrimeAcquisitionName,
            },
        };
    }

    primeRepeat(keys, templates, primeInfo = {}) {
        return {
            template: {
                name: this.CONST.templatePrimeRepeatName,
            },
        };
    }
}

module.exports = UIDataBuilder;
